import BaseType from "../BaseType";
export default class Enumeration extends BaseType {
  LocalizationKey: string = "";
  Description: string = "";
  Value: string = "";
}
